"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard"),
    _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports["default"] = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator")),
    _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties")),
    _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator")),
    _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray")),
    _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty")),
    _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck")),
    _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass")),
    _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits")),
    _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn")),
    _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf")),
    _react = _interopRequireWildcard(require("react")),
    _validator = require("validator"),
    _uiKit = require("@devsta/ui-kit"),
    _memoizeOne = _interopRequireDefault(require("memoize-one")),
    _lodash = _interopRequireDefault(require("lodash.memoize")),
    _getValueFromGenericInput = require("@devsta/get-value-from-generic-input"),
    _SocialProfiles = _interopRequireDefault(require("../../SocialProfiles"));

require("../styles/_basic-user-profile.scss");

function ownKeys(a, b) {
  var c = Object.keys(a);

  if (Object.getOwnPropertySymbols) {
    var d = Object.getOwnPropertySymbols(a);
    b && (d = d.filter(function (b) {
      return Object.getOwnPropertyDescriptor(a, b).enumerable;
    })), c.push.apply(c, d);
  }

  return c;
}

function _objectSpread(a) {
  for (var b, c = 1; c < arguments.length; c++) {
    b = null == arguments[c] ? {} : arguments[c], c % 2 ? ownKeys(Object(b), !0).forEach(function (c) {
      (0, _defineProperty2["default"])(a, c, b[c]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(a, Object.getOwnPropertyDescriptors(b)) : ownKeys(Object(b)).forEach(function (c) {
      Object.defineProperty(a, c, Object.getOwnPropertyDescriptor(b, c));
    });
  }

  return a;
}

function _createSuper(a) {
  var b = _isNativeReflectConstruct();

  return function () {
    var c,
        d = (0, _getPrototypeOf2["default"])(a);

    if (b) {
      var e = (0, _getPrototypeOf2["default"])(this).constructor;
      c = Reflect.construct(d, arguments, e);
    } else c = d.apply(this, arguments);

    return (0, _possibleConstructorReturn2["default"])(this, c);
  };
}

function _isNativeReflectConstruct() {
  if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
  if (Reflect.construct.sham) return !1;
  if ("function" == typeof Proxy) return !0;

  try {
    return Date.prototype.toString.call(Reflect.construct(Date, [], function () {})), !0;
  } catch (a) {
    return !1;
  }
}

var isValidEmail = (0, _memoizeOne["default"])(_validator.isEmail);

function getDefaultUserStringValue(a) {
  return function (b) {
    return a && a[b] || "";
  };
}

var BasicUserProfile = function (a) {
  function b(a) {
    var d;
    (0, _classCallCheck2["default"])(this, b), d = c.call(this, a), d.updateInputField = (0, _lodash["default"])(function (a) {
      return function (b) {
        d.setState((0, _defineProperty2["default"])({}, a, (0, _getValueFromGenericInput.getStringValueFromGenericInput)(b)));
      };
    }), d.onValidatePhoneNumber = (0, _lodash["default"])(function (a) {
      return function (b) {
        d.setState((0, _defineProperty2["default"])({}, "".concat(a, "Valid"), b));
      };
    }), d.handleSelectImage = function (a) {
      var b = a.slice(-1),
          c = (0, _slicedToArray2["default"])(b, 1),
          e = c[0];
      d.setState({
        imageUrl: e.preview.url,
        imageFile: e
      });
    }, d.onSave = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function a() {
      var b, c, e, f, g, h, i, j;
      return _regenerator["default"].wrap(function (a) {
        for (;;) {
          switch (a.prev = a.next) {
            case 0:
              return b = d.props.onSave, c = d.state, e = c.phoneNumber, f = c.workNumber, g = c.socialProfiles, h = c.phoneNumberValid, i = c.workNumberValid, j = (0, _objectWithoutProperties2["default"])(c, ["phoneNumber", "workNumber", "socialProfiles", "phoneNumberValid", "workNumberValid"]), a.next = 4, b(_objectSpread(_objectSpread({}, j), {}, {
                phoneNumber: e,
                workNumber: f || "",
                linkedInUrl: g.linkedIn || ""
              }));

            case 4:
            case "end":
              return a.stop();
          }
        }
      }, a);
    }));
    var e = a.user,
        f = getDefaultUserStringValue(e);
    return d.state = {
      imageUrl: f("imageUrl"),
      firstName: f("firstName"),
      lastName: f("lastName"),
      jobTitle: f("jobTitle"),
      department: f("department"),
      email: f("email"),
      phoneNumber: f("phoneNumber"),
      workNumber: f("workNumber"),
      officeLocation: f("officeLocation"),
      socialProfiles: {
        linkedIn: f("linkedInUrl")
      },
      imageFile: void 0,
      phoneNumberValid: !0,
      workNumberValid: !0
    }, d;
  }

  (0, _inherits2["default"])(b, a);

  var c = _createSuper(b);

  return (0, _createClass2["default"])(b, [{
    key: "isValidUser",
    value: function isValidUser() {
      var a = this.state,
          b = a.firstName,
          c = a.lastName,
          d = a.email,
          e = a.phoneNumber,
          f = a.jobTitle,
          g = a.phoneNumberValid,
          h = a.workNumberValid;
      return b && c && d && e && g && h && f;
    }
  }, {
    key: "render",
    value: function render() {
      var a = this.state,
          b = a.socialProfiles,
          c = a.firstName,
          d = a.lastName,
          e = a.email,
          f = a.jobTitle,
          g = a.officeLocation,
          h = a.phoneNumber,
          i = a.department,
          j = a.imageUrl,
          k = this.props,
          l = k.saveBtnText,
          m = k.saving;
      return _react["default"].createElement("div", {
        className: "basic-user-profile"
      }, _react["default"].createElement(_SocialProfiles["default"], {
        className: "basic-user-profile__details",
        title: "User Profile",
        socialProfiles: b,
        onSave: this.updateInputField("socialProfiles"),
        defaultImage: "user",
        imagePlaceholder: "".concat(c, " ").concat(d),
        modalTitle: "LinkedIn Profile",
        buttonTitle: "LinkedIn",
        allowedSocialTypes: ["linkedIn"],
        onSelectImage: this.handleSelectImage,
        profileImage: j
      }), _react["default"].createElement("div", {
        className: "basic-user-profile__fields-container"
      }, _react["default"].createElement("div", {
        className: "basic-user-profile__split-row"
      }, _react["default"].createElement(_uiKit.Input, {
        id: "firstname-input",
        placeholder: "Enter first name",
        label: "First Name",
        labelProps: {
          required: !0
        },
        onChange: this.updateInputField("firstName"),
        defaultValue: c
      }), _react["default"].createElement(_uiKit.Input, {
        id: "lastname-input",
        placeholder: "Enter last name",
        label: "Last Name",
        labelProps: {
          required: !0
        },
        onChange: this.updateInputField("lastName"),
        defaultValue: d
      })), _react["default"].createElement(_uiKit.Input, {
        id: "email-input",
        placeholder: "Enter email",
        label: "Email Address",
        labelProps: {
          required: !0
        },
        validate: isValidEmail,
        onChange: this.updateInputField("email"),
        errorMessage: "Please enter a valid email address",
        defaultValue: e
      }), _react["default"].createElement("div", {
        className: "basic-user-profile__split-row"
      }, _react["default"].createElement(_uiKit.Input, {
        id: "jobtitle-input",
        placeholder: "Enter job title",
        label: "Job Title",
        labelProps: {
          required: !0
        },
        onChange: this.updateInputField("jobTitle"),
        defaultValue: f
      }), _react["default"].createElement(_uiKit.Input, {
        id: "department-input",
        placeholder: "Enter department",
        label: "Department",
        onChange: this.updateInputField("department"),
        defaultValue: i
      })), _react["default"].createElement(_uiKit.PhoneNumberInput, {
        id: "contactnumber-input",
        placeholder: "Enter contact number",
        label: "Contact Number",
        labelProps: {
          required: !0
        },
        onChange: this.updateInputField("phoneNumber"),
        onValidate: this.onValidatePhoneNumber("phoneNumber"),
        initialNumber: h,
        emptyIsValid: !0
      }), _react["default"].createElement(_uiKit.Input, {
        id: "officelocation-input",
        placeholder: "Enter office location",
        label: "Office Location",
        onChange: this.updateInputField("officeLocation"),
        defaultValue: g
      })), _react["default"].createElement(_uiKit.Button, {
        "data-cy": "profile-submit-button",
        busy: m,
        onClick: this.onSave,
        disabled: !(this.isValidUser() && isValidEmail(e))
      }, l));
    }
  }]), b;
}(_react.Component);

exports["default"] = BasicUserProfile, BasicUserProfile.defaultProps = {
  saveBtnText: "Save & Continue"
};